import { List } from "antd";
import styles from "./UnitListByType.module.scss";
import { useNavigate } from "react-router-dom";
const UnitListByType = ({ roles }) => {
  const navigate = useNavigate();
  return (
    <div className={styles["role-list-by-type"]}>
      {roles.type == 2 ? (
        <div className={styles["unit-roles"]}>
          <p className={styles["title"]}>Units:</p>
          <div className={styles["roles"]}>
            <List
              grid={{
                gutter: 25,
                column: 3,
              }}
              dataSource={roles.data}
              renderItem={(item, index) => {
                return (
                  <List.Item key={index}>
                    <div
                      className={styles["unit-role"]}
                      key={index}
                      onClick={() => {
                        navigate(
                          `/admin/units/${item.scope_id}-${roles.type}/summary`
                        );
                      }}
                    >
                      <p className={styles["role-name"]}>
                        <span className={styles["entity-title"]}>Name:</span>{" "}
                        {item.name}
                      </p>
                      <p>
                        <span className={styles["entity-title"]}>Scope:</span>{" "}
                        {item.scope_name}
                      </p>
                      <p>
                        <span className={styles["entity-title"]}>
                          Permissions:
                        </span>{" "}
                        {item.permissions.map((permission, i) => {
                          if (i !== item.permissions.length - 1)
                            return (
                              <span key={i}>
                                {permission}
                                {", "}
                              </span>
                            );
                          else {
                            return <span key={i}>{permission}.</span>;
                          }
                        })}
                      </p>
                    </div>
                  </List.Item>
                );
              }}
            />
          </div>
        </div>
      ) : roles.type == 3 ? (
        <div className={styles["personal-profile-roles"]}>
          <p className={styles["title"]}>Personal profile:</p>
          <div className={styles["roles"]}>
            <List
              grid={{
                gutter: 25,
                column: 3,
              }}
              dataSource={roles.data}
              renderItem={(item, index) => {
                return (
                  <List.Item key={index}>
                    <div
                      className={styles["personal-profile-role"]}
                      key={index}
                    >
                      <p className={styles["role-name"]}>
                        <span className={styles["entity-title"]}>Name:</span>{" "}
                        {item.name}
                      </p>
                      <p>
                        <span className={styles["entity-title"]}>Scope:</span>{" "}
                        {item.scope_name}
                      </p>
                      <p>
                        <span className={styles["entity-title"]}>
                          Permissions:
                        </span>{" "}
                        {item.permissions.map((permission, i) => {
                          if (i !== item.permissions.length - 1)
                            return (
                              <span key={i}>
                                {permission}
                                {", "}
                              </span>
                            );
                          else {
                            return <span key={i}>{permission}.</span>;
                          }
                        })}
                      </p>
                    </div>
                  </List.Item>
                );
              }}
            />
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default UnitListByType;
